function cartSummaryComponent() {
    $('.open-discount').on('click', function() {
        $('.discount-summary').slideToggle();
    });
}